<template>
  <div id="app-about-friend">
    <h1>友情链接 <em class="el-icon-link"></em></h1>
    <div id="app-about-friend-body">
      <ul>
        <li v-for="item in friendCardList" :key="item.id" style="float:left">
          <el-card class="app-about-friend-card">
            <div v-if="item.isLogo">
              <a :href="item.link" target="_blank"><img alt="pic" style="height: 64px;width: 170px" :src="item.img"/></a>
            </div>
            <div v-else>
              <img alt="pic" style="height: 64px;width: 64px;float:left;" src="http://iph.href.lu/64x64"/>
              <div style="line-height: 64px;text-align: center">123456</div>
            </div>
          </el-card>
        </li>
      </ul>
      <div style="clear:both;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FriendLink",
  data() {
    return {
      friendCardList: [
        {
          isLogo: true,
          link: 'https://www.blendercn.org/',
          img: 'https://img.blendermagic.cn/new/about/friend/friendLink1.jpg',
        }
      ]
    }
  }
}
</script>

<style scoped>

#app-about-friend {
  width: 100%;
  text-align: center;
  padding-top: 25px;
}

#app-about-friend-body {
  padding-top: 50px;
}

.app-about-friend-card {
  width: 170px;
  height: 65px;
  margin-left: 95px;
  margin-bottom: 40px;
  border: 0;
  cursor: pointer;
}

.app-about-friend-card:hover {
  transition: all 1s ease-out;
  transform: scale(1.1);
}

</style>